import { useEffect, useState } from 'react';

export type ThemeName = 'dark' | 'light';

function getInitialTheme(): ThemeName {
  const savedTheme = window.localStorage.getItem('una-theme');
  return savedTheme === 'light' || savedTheme === 'dark' ? savedTheme : 'dark';
}

export function useTheme() {
  const [theme, setTheme] = useState<ThemeName>(getInitialTheme);
  const isDarkTheme = theme === 'dark';

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    window.localStorage.setItem('una-theme', theme);
  }, [theme]);

  function toggleTheme() {
    setTheme((currentTheme) => (currentTheme === 'dark' ? 'light' : 'dark'));
  }

  return {
    isDarkTheme,
    theme,
    toggleTheme,
  };
}
